window.TV2 = window.TV2 || {};
/**
 * Initialize video
 * @param videoparams
 * @constructor
 */
window.TV2.TV2Video = (videoparams) => {
  // TODO: Change videoparams to be same as video player
  const defaults = {
    itemId: null,
    autoPlay: false,
    adsEnabled: true,
    isLive: false,
    externalImage: false,
    isProd: true,
    appMode: false,
    playlist: [],
    playlistSelectorEnabled: false,
    allowMutedAutoplay: false,
    suspendAdPlayback: false,
    adBlockContentBlock: false,
    forceMobileAutoplay: false,
    upNextTimeOffset: 5,
    loopPlaylist: false,
    autoFront: false,
    autoFrontInited: false,
    updateExternal: false,
    initedAsset: null,
    pipEnabled: false,
    overlayAdOptions: null,
    useSticky: false,
  };

  // Merge defaults and specific video parameters
  const params = { ...defaults, ...videoparams };

  const videoContainer = document.getElementById(`video_placeholder_${params.container}`);
  params.player = null;

  if (videoContainer === null) return;
  params.videoContainer = videoContainer;

  let playlist;
  try {
    playlist = JSON.parse(params.playlist);
  } catch (e) {
    playlist = [];
  }

  params.playlist = playlist;

  const updateMetadata = (a) => {
    const title = videoContainer.parentElement.querySelector(
      '.tv2video__title-container .tv2video__title',
    );
    if (title) {
      title.textContent = a.title;
    }
    const kicker = videoContainer.parentElement.querySelector(
      '.tv2video__title-container .tv2video__kicker',
    );
    if (kicker) {
      kicker.textContent = a.category_title;
    }
    const duration = window.TV2.getReadableDuration(a.duration);
    const metadur = videoContainer.parentElement.querySelector(
      '.tv2video__title-container .tv2video__metadata span[data-duration]',
    );
    if (metadur) {
      metadur.textContent = duration;
      metadur.setAttribute('data-duration', duration);
    }
    const metadate = videoContainer.parentElement.querySelector(
      '.tv2video__title-container .tv2video__metadata span[data-published]',
    );
    if (metadate) {
      const published = window.TV2.timeSince(new Date(a.live_broadcast_time));
      metadate.textContent = published;
      metadate.setAttribute('data-published', a.liveBroadcastTime);
    }
    const metaviews = videoContainer.parentElement.querySelector(
      '.tv2video__title-container .tv2video__metadata span[data-views]',
    );
    if (metaviews) {
      metaviews.textContent = a.views
        ? a.views.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        : '';
      metaviews.setAttribute('data-views', a.views);
    }
  };

  const stickyPlayer = (targetId, sticky) => {
    if (sticky) {
      const stickyObj = document.querySelector(`#tv2video_${targetId}`);
      if (!stickyObj) {
        return false;
      }
      const header = document.querySelector('.main-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const topMargin = 0;
      const stickyGhost = document.createElement('div');

      const setSticky = TV2.throttle(() => {
        const rect = stickyObj.getBoundingClientRect();
        const offset = Math.round(rect.top);
        stickyGhost.style.height = parseInt(rect.height, 10) + 'px';
        const scrollTarget = headerHeight + topMargin;
        const isSticked = stickyObj.classList.contains('tv2video--sticky');

        if (scrollTarget >= offset && !isSticked) {
          stickyObj.classList.add('tv2video--sticky');
          stickyObj.firstElementChild.style.top = headerHeight + 'px';
          stickyObj.appendChild(stickyGhost);
        } else if (scrollTarget < offset && isSticked) {
          stickyObj.classList.remove('tv2video--sticky');
          stickyObj.firstElementChild.style.top = null;
          stickyObj.removeChild(stickyGhost);
        }
      }, 100);
      setSticky();
      window.addEventListener('scroll', setSticky);
    }
  };

  const startVideo = (parameters) => {
    const opt = parameters;
    const asset = {
      assetId: parseInt(opt.assetId, 10),
      indexPointId: opt.itemId && opt.itemId !== '' ? parseInt(opt.itemId, 10) : null,
      posterUrl: opt.externalImage || opt.fallbackImage || null,
      playlist: opt.playlist,
      startMuted: opt.startMuted,
      autoPlay: opt.autoPlay,
      className: 'tv2p-tv2video',
    };

    const container = {
      mainContainer: `video_placeholder_${opt.container}`,
    };

    const config = {
      appDomain: 'tv2',
      appName: 'TV2.no',
      adsEnabled: opt.adsEnabled,
      isProd: opt.isProd,
      allowMutedAutoplay: opt.allowMutedAutoplay,
      suspendAdPlayback: opt.suspendAdPlayback,
      adBlockContentBlock: opt.adBlockContentBlock,
      forceMobileAutoplay: opt.forceMobileAutoplay,
      upNextTimeOffset: opt.upNextTimeOffset,
      loopPlaylist: opt.loopPlaylist,
      pipEnabled: opt.pipEnabled,
      overlayAdOptions: opt.overlayAdOptions,
      playlistSelectorEnabled: opt.playlistSelectorEnabled,
    };

    function customCallback1(tv2video) {
      if (opt.updateExternal) {
        if (!opt.initedAsset || opt.initedAsset !== tv2video.asset.id) {
          opt.initedAsset = tv2video.asset.id;
          updateMetadata(tv2video.asset);
        }
      }

      if (opt.autoFront) {
        const autoFrontTitles = window.TV2.FrontVideo(params.container, params.playlist);
        if (!opt.autoFrontInited) {
          opt.autoFrontInited = true;
          window.TV2.VideoInView(opt.container, tv2video);
        } else {
          if (tv2video.player.state === 'PAUSED') {
            autoFrontTitles.setPause(tv2video.asset);
          }
          if (tv2video.player.state === 'READY') {
            autoFrontTitles.setTitle(tv2video.asset);
          }
        }
      }
    }

    // Init player
    window.tv2PlayerInsert(asset, config, container.mainContainer, { customCallback1 });

    if (opt.useSticky) {
      stickyPlayer(opt.container, true);
    }
  };

  startVideo(params);
};
